var render = function render(){var _vm=this,_c=_vm._self._c;return _c('location-maps-record',{on:{"acceptLocation":_vm.acceptLocation}})
}
var staticRenderFns = []

export { render, staticRenderFns }